import { forEach } from 'es-toolkit/compat';
import AppConstants from 'constants/AppConstants';

export function initializeTableEdits(tables: Table[]): BaseTockAction {
  const tablesObj: {
    [tableId: number]: Table;
  } = {};
  forEach(tables, (table) => {
    tablesObj[table.id] = table;
  });

  return {
    type: AppConstants.TABLE_EDITS_INITIALIZE,
    payload: tablesObj,
  };
}

export function updateTableLocation(tableId: number, tableLocation: TableLocation): BaseTockAction {
  return {
    type: AppConstants.TABLE_EDITS_UPDATE_TABLE_LOCATION,
    payload: {
      tableId,
      tableLocation,
    },
  };
}
